module.exports = __webpack_public_path__ + "img/filter-type.2be0b042.svg";